import Vue from "vue";
import ServiceUtils from '@/common/utils/ServiceUtils'
import _ from "lodash";

Vue.directive('convert-kana-word', function (el, binding, vnode) {
    const handler = function (e) {
        const valueInput = e.target.value;
        let value = ServiceUtils.convertHalfwidthToFullwidthReturn(valueInput);
        value && (value = ServiceUtils.onlyfullkatakanaReturn(value));
        value && (value = ServiceUtils.convertToEmhyphen(value));
        e.target.value = value
        vnode.elm.dispatchEvent(new CustomEvent('input'));
    };
    addMultiEvent(['blur', 'change'], el, handler);

});

const addMultiEvent = (events, el, handle) => {
    if (_.isArray(events) && !_.isEmpty(events)) {
        events.forEach(evt =>
            el.addEventListener(evt, handle, false)
        );
    }

};
